import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=5bdea392"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=5bdea392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports